import axios from 'axios';
import store from '@/store/'


// Account 相關的 api
const accountRequest = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN+'/auth'
});

//登入API
export const apiAccountLogin = data => accountRequest.post('/login', data);
//開發環境用戶直接登入API
export const apiAccountDirectUserLogin = data => accountRequest.post('/direct-user-login', data);
//狀態API
export const apiAccountMe = (data) => accountRequest.get('/me',{
    params : data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});